import { render, staticRenderFns } from "./profileNav.vue?vue&type=template&id=7d1a4983&scoped=true&"
import script from "./profileNav.vue?vue&type=script&lang=js&"
export * from "./profileNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1a4983",
  null
  
)

export default component.exports